import { useEffect, useRef } from 'react'

// Overlays a click can land in without leaving the selection.
const KEEP_SELECTION = '.modal, .popover, .dropdown-menu, .tooltip, .assistant-sidebar, .Toastify'

// Menus, date pickers and backdrops portalled to <body> render beside the app root, not in it.
const isPortalled = (target) => {
  const root = document.getElementById('root')
  return !!root && target !== document.body && target !== document.documentElement && !root.contains(target)
}

// Calls onClear for a click anywhere on the page while `active`, including the grey background
// around the canvas. Selectable cards stop their own clicks' propagation, so those never reach here.
export const useClearOnOutsideClick = (active, onClear) => {
  const onClearRef = useRef(onClear)
  onClearRef.current = onClear

  useEffect(() => {
    if (!active) return undefined
    const handleClick = (event) => {
      const { target } = event
      if (!target.isConnected || target.closest?.(KEEP_SELECTION) || isPortalled(target)) return
      onClearRef.current()
    }
    document.addEventListener('click', handleClick)
    return () => document.removeEventListener('click', handleClick)
  }, [active])
}
